import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SelectValue } from 'app/interfaces/select-value.interface';

@Component({
    selector: 'app-select-box',
    templateUrl: './select-box.component.html',
    styleUrls: ['./select-box.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule
    ]
})
export class SelectBoxComponent implements OnInit {
    @Input() small: boolean = false;
    @Input() values: SelectValue[];
    @Input() isOpen: boolean = false;
    @Input() customHeight?: string
    @Output() isOpenChange = new EventEmitter<boolean>();
    @Output() valueSelected = new EventEmitter<SelectValue>();

    valuesList: SelectValue[];
    firstClick = true;

    @HostListener('document:click', ['$event'])
    clickout(event: MouseEvent) {
        if (!this.firstClick && this.isOpen && event.target && !this.eRef.nativeElement.contains(event.target)) {
            this.isOpenChange.emit(false);
        }
        this.firstClick = false;
    }

    constructor(private eRef: ElementRef) {}

    ngOnInit() {
        this.valuesList = [...this.values];
    }

    ngOnChanges() {
        if (this.values) {
            this.valuesList = [...this.values];
        }
    }

    onClick(value: SelectValue) {
        if(this.values?.length > 0){
            this.valueSelected.emit(value);
            this.isOpenChange.emit(false);
        }
    }
}
